import { Component } from "@angular/core";
import { SelectWindow, ModalService } from "@xo/client-common";
import { Type2LongString, Type2LongStringType } from "./Type2LongString";

@Component({
    selector: "spec-app-type2-long-string-select",
    templateUrl: "./type2LongString.select.html",
    styleUrls: ["./type2LongString.select.scss"]
})
export class Type2LongStringSelect extends SelectWindow<Type2LongString> {

    constructor(modalService: ModalService) {
        super(modalService, Type2LongStringType, "simpleField");
    }
}
